import { render, staticRenderFns } from "./dentition-space.vue?vue&type=template&id=057f22ef&scoped=true"
import script from "./dentition-space.vue?vue&type=script&lang=js"
export * from "./dentition-space.vue?vue&type=script&lang=js"
import style0 from "./dentition-space.vue?vue&type=style&index=0&id=057f22ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f22ef",
  null
  
)

export default component.exports